// AUTO-GENERATED central icon module. Single source of truth for all icons.
// Re-exports Iconoir icons under the previous (lucide) names, wrapped so the
// `size` prop keeps working. To change an icon app-wide, edit it here only.
import { forwardRef, createElement } from 'react';
import type { SVGProps, ComponentType } from 'react';
import { Loader2 as _Loader2 } from 'lucide-react';
import {
  ArrowLeft as _ArrowLeft,
  ArrowRight as _ArrowRight,
  ArrowSeparateVertical as _ArrowSeparateVertical,
  Attachment as _Attachment,
  Bell as _Bell,
  Building as _Building,
  Calendar as _Calendar,
  Camera as _Camera,
  ChatBubble as _ChatBubble,
  ChatPlusIn as _ChatPlusIn,
  Check as _Check,
  CheckCircle as _CheckCircle,
  Clock as _Clock,
  Coins as _Coins,
  DoubleCheck as _DoubleCheck,
  Download as _Download,
  DragHandGesture as _DragHandGesture,
  Edit as _Edit,
  EditPencil as _EditPencil,
  Expand as _Expand,
  Filter as _Filter,
  Globe as _Globe,
  Group as _Group,
  HalfMoon as _HalfMoon,
  Home as _Home,
  InfoCircle as _InfoCircle,
  Label as _Label,
  Lock as _Lock,
  LogOut as _LogOut,
  Mail as _Mail,
  MapPin as _MapPin,
  MediaImage as _MediaImage,
  MoreHoriz as _MoreHoriz,
  NavArrowDown as _NavArrowDown,
  MagicWand as _MagicWand,
  NavArrowLeft as _NavArrowLeft,
  NavArrowRight as _NavArrowRight,
  NavArrowUp as _NavArrowUp,
  OpenNewWindow as _OpenNewWindow,
  Package as _Package,
  Page as _Page,
  Percentage as _Percentage,
  Phone as _Phone,
  Plus as _Plus,
  Prohibition as _Prohibition,
  RefreshDouble as _RefreshDouble,
  Reports as _Reports,
  Search as _Search,
  SendDiagonal as _SendDiagonal,
  Settings as _Settings,
  Shield as _Shield,
  ShieldCheck as _ShieldCheck,
  ShieldXmark as _ShieldXmark,
  Sparks as _Sparks,
  Star as _Star,
  StatsReport as _StatsReport,
  Suitcase as _Suitcase,
  SunLight as _SunLight,
  Table as _Table,
  TaskList as _TaskList,
  Trash as _Trash,
  Trophy as _Trophy,
  Undo as _Undo,
  Upload as _Upload,
  User as _User,
  UserStar as _UserStar,
  ViewGrid as _ViewGrid,
  WarningCircle as _WarningCircle,
  WarningTriangle as _WarningTriangle,
  Xmark as _Xmark,
  XmarkCircle as _XmarkCircle,
} from 'iconoir-react';

export type IconProps = Omit<SVGProps<SVGSVGElement>, 'ref'> & { size?: number | string };

function icon(Cmp: ComponentType<SVGProps<SVGSVGElement>>) {
  return forwardRef<SVGSVGElement, IconProps>(function Icon({ size, width, height, ...rest }, ref) {
    return createElement(Cmp, { ref, width: width ?? size ?? 24, height: height ?? size ?? 24, ...rest });
  });
}

export const AlertCircle = icon(_WarningCircle);
export const AlertTriangle = icon(_WarningTriangle);
export const ArrowLeft = icon(_ArrowLeft);
export const ArrowRight = icon(_ArrowRight);
export const ArrowUpDown = icon(_ArrowSeparateVertical);
export const Ban = icon(_Prohibition);
export const BarChart3 = icon(_StatsReport);
export const Bell = icon(_Bell);
export const Briefcase = icon(_Suitcase);
export const Building2 = icon(_Building);
export const Calendar = icon(_Calendar);
export const CalendarClock = icon(_Calendar);
export const CalendarIcon = icon(_Calendar);
export const Camera = icon(_Camera);
export const Check = icon(_Check);
export const CheckCheck = icon(_DoubleCheck);
export const CheckCircle = icon(_CheckCircle);
export const CheckCircle2 = icon(_CheckCircle);
export const ChevronDown = icon(_NavArrowDown);
export const ChevronLeft = icon(_NavArrowLeft);
export const ChevronRight = icon(_NavArrowRight);
export const ChevronUp = icon(_NavArrowUp);
export const ChevronsUpDown = icon(_ArrowSeparateVertical);
export const ClipboardList = icon(_TaskList);
export const Clock = icon(_Clock);
export const Coins = icon(_Coins);
export const Download = icon(_Download);
export const ExternalLink = icon(_OpenNewWindow);
export const File = icon(_Page);
export const FileSpreadsheet = icon(_Table);
export const FileText = icon(_Page);
export const Filter = icon(_Filter);
export const Globe = icon(_Globe);
export const GripVertical = icon(_DragHandGesture);
export const Handshake = icon(_Suitcase);
export const Home = icon(_Home);
export const Image = icon(_MediaImage);
export const Info = icon(_InfoCircle);
export const Layers = icon(_Reports);
export const LayoutGrid = icon(_ViewGrid);
export const Lock = icon(_Lock);
export const LogOut = icon(_LogOut);
export const Mail = icon(_Mail);
export const MapPin = icon(_MapPin);
export const Maximize2 = icon(_Expand);
export const MessageSquare = icon(_ChatBubble);
export const MessageSquarePlus = icon(_ChatPlusIn);
export const Moon = icon(_HalfMoon);
export const MoreHorizontal = icon(_MoreHoriz);
export const Package = icon(_Package);
export const Paperclip = icon(_Attachment);
export const PenLine = icon(_Edit);
export const Pencil = icon(_EditPencil);
export const Percent = icon(_Percentage);
export const Phone = icon(_Phone);
export const Plus = icon(_Plus);
export const RefreshCw = icon(_RefreshDouble);
export const RotateCcw = icon(_Undo);
export const Search = icon(_Search);
export const Send = icon(_SendDiagonal);
export const Settings = icon(_Settings);
export const Shield = icon(_Shield);
export const ShieldCheck = icon(_ShieldCheck);
export const ShieldOff = icon(_ShieldXmark);
export const Sparkles = icon(_Sparks);
export const MagicWand = icon(_MagicWand);
export const Star = icon(_Star);
export const Sun = icon(_SunLight);
export const Table2 = icon(_Table);
export const Tag = icon(_Label);
export const Trash2 = icon(_Trash);
export const Trophy = icon(_Trophy);
export const Upload = icon(_Upload);
export const User = icon(_User);
export const UserRound = icon(_User);
export const UserSearch = icon(_UserStar);
export const Users = icon(_Group);
export const X = icon(_Xmark);
export const XCircle = icon(_XmarkCircle);
// Spinner kept from lucide (Iconoir has no equivalent).
export const Loader2 = icon(_Loader2 as unknown as ComponentType<SVGProps<SVGSVGElement>>);
